
import React from 'react';

interface Service {
  id: number;
  title: string;
  items: string[];
  icon: string;
}

const services: Service[] = [
  {
    id: 1,
    title: 'DAÑOS Y PERJUICIOS',
    icon: 'ri-shield-check-line',
    items: [
      'Accidentes de tránsito',
      'Accidentes laborales (ART)',
      'Mala Praxis',
      'Incumplimiento de contratos',
    ],
  },
  {
    id: 2,
    title: 'FAMILIA',
    icon: 'ri-home-4-line',
    items: [
      'Cuota alimentaria',
      'Divorcio',
      'Sucesiones',
      'Violencia familiar',
    ],
  },
  {
    id: 3,
    title: 'ASUNTOS CIVILES',
    icon: 'ri-file-text-line',
    items: [
      'Contratos',
      'Constitución S.A.S Y S.R.L',
      'Derecho inmobiliario',
      'Mediación y resolución de conflictos',
    ],
  },
];

export default function ServicesSection() {
  return (
    <section id="servicios" className="pt-0 pb-16 md:pb-24 bg-[#0d1a2a]">
      <div className="max-w-7xl mx-auto px-5 md:px-6 lg:px-20">
        {/* Header */}
        <div className="text-center mb-10 md:mb-16">
          <div className="inline-flex items-center gap-2 border border-[#B89A5A]/30 rounded-full px-4 md:px-5 py-2 mb-5 md:mb-6">
            <span className="text-[#B89A5A] text-xs md:text-sm font-medium tracking-wider">
              ÁREAS DE PRÁCTICA
            </span>
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-white mb-3 md:mb-4">
            Servicios Especializados
          </h2>
          <p className="text-base md:text-lg text-white/60 max-w-2xl mx-auto">
            Asesoramiento integral en diversas ramas del derecho
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {services.map((service) => (
            <div
              key={service.id}
              className="relative bg-[#14253D]/60 border border-white/8 rounded-[24px] md:rounded-[30px] overflow-hidden p-6 md:p-8 lg:p-10"
            >
              {/* Decorative top accent */}
              <div className="absolute top-0 left-6 right-6 md:left-8 md:right-8 h-[2px] bg-gradient-to-r from-transparent via-[#B89A5A]/40 to-transparent"></div>

              <div className="relative h-full flex flex-col">
                <div className="mb-6 md:mb-8">
                  <div className="w-14 h-14 md:w-16 md:h-16 bg-[#B89A5A]/15 rounded-2xl flex items-center justify-center mb-5 md:mb-6">
                    <i
                      className={`${service.icon} text-2xl md:text-3xl text-[#B89A5A]`}
                      aria-hidden="true"
                    ></i>
                  </div>
                  <h3 className="text-lg md:text-xl lg:text-2xl font-serif font-bold text-white mb-2 tracking-wide">
                    {service.title}
                  </h3>
                  <div className="w-10 h-[2px] bg-[#B89A5A] rounded-full"></div>
                </div>

                <ul className="space-y-3 md:space-y-4 flex-1">
                  {service.items.map((item, index) => (
                    <li key={index} className="flex items-start gap-3">
                      <span className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                        <i
                          className="ri-arrow-right-s-line text-[#B89A5A] text-lg"
                          aria-hidden="true"
                        ></i>
                      </span>
                      <span className="text-white/75 text-sm md:text-base">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
